import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import golbal from './token';

const store = new Vuex.Store({

  ...golbal,
  modules: {
  }
});


export {
  store
};


// WEBPACK FOOTER //
// ./src/store/index.js